import React from "react"
import _get from "lodash/get"
import { sanitizeTextArticle } from "@/utils/helper"
import { addAnalyticsArticleClick } from "@/components/MyFavorites/analytics"

const ArticleTile = ({ data, locale }) => {
  const link = _get(data, "custom.fields.link", "")
  const categoryName = _get(data, "custom.fields.articleType", "")
  const title = _get(data, `name[${locale}]`, "")
  const description = _get(data, `description[${locale}]`, "")
  const thumbnail = _get(data, "custom.fields.thumbnail", "")

  return (
    <a
      href={link}
      className="article-tile"
      aria-label={title}
      onClick={() => addAnalyticsArticleClick(title.toLowerCase(), link)}
      data-siteWideWarning-added="true"
    >
      <div className="content-section">
        <div className="category-name">{categoryName}</div>
        <div className="article-title">{title}</div>
        {description && (
          <div className="description">{sanitizeTextArticle(description)}</div>
        )}
      </div>
      {thumbnail && (
        <div className="image-section">
          <img src={thumbnail} alt="image" />
        </div>
      )}
    </a>
  )
}

export default ArticleTile
